/** Popup : display / hide */
export function popup() {
  /** Open */

  $(".btn--popup").each(function () {
    let dataPopup = $(this).data('popup');
    $(this).on("click", function () {
      $("#" + dataPopup).addClass("popup--active");
    });
  });

  /** Close */
  const closeButtons = document.querySelectorAll(
    ".popup__close, .popup__overlay"
  );

  closeButtons.forEach(function (closeButton) {
    let dataPopup = closeButton.dataset.popup;
    let popup = document.getElementById(dataPopup);
    closeButton.onclick = function () {
      popup.classList.remove("popup--active");
    };
  });
}
